import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

export const TENANT_CONTEXT_QUERY = gql`
  query compassInfo($cloudIds: [ID!]) {
    tenantContexts(cloudIds: $cloudIds) {
      cloudId
      hostName
    }
  }
`;

type TenantContext = {
  cloudId: string;
  hostName: string;
};

type TenantContextQueryResponse = {
  tenantContexts: TenantContext[];
};

type TenantContextQueryVariables = {
  cloudIds: string[];
};

type ReturnType = {
  siteUrl: string | null;
  compassBitbucketAppAdminPageUrl: string | null;
  loading: boolean;
  error?: Error | null;
};

const BITBUCKET_ADMIN_PAGE_EXTENSION = `ari:cloud:ecosystem::extension/05175914-734f-4887-b303-4ad44d6c3a34/575409ba-ad7d-4f51-9665-d7371cd32854/static/bitbucket-admin`;

/**
 * It makes a GraphQL call to get Tenant data.
 * @param cloudId connected to the BBC workspace
 * @returns the Compass site URL that is connected and the Compass Bitbucket integration forge app's setup URL, accessible by an admin.
 */
export const useCompassSiteInfo = (cloudId?: string): ReturnType => {
  const { data, loading, error } = useQuery<
    TenantContextQueryResponse,
    TenantContextQueryVariables
  >(TENANT_CONTEXT_QUERY, {
    variables: {
      cloudIds: cloudId ? [cloudId] : [],
    },
    skip: !cloudId,
  });

  const tenantInfo = data?.tenantContexts?.[0];

  const siteUrl = tenantInfo ? `https://${tenantInfo.hostName}` : null;
  const compassBitbucketAppAdminPageUrl = siteUrl
    ? `${siteUrl}/compass/apps/b:${window.btoa(BITBUCKET_ADMIN_PAGE_EXTENSION)}`
    : null;

  return {
    siteUrl,
    compassBitbucketAppAdminPageUrl,
    loading,
    error: error ? new Error(error.message) : null,
  };
};
